import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};

// path('', HSNCodeListView.as_view(), name='hsncode-list'),
//     path('create/', HSNCodeCreateView.as_view(), name='hsncode-create'),
//     path('<int:pk>/get/', HSNCodeRetrieveView.as_view(), name='hsncode-retrieve'),
//     path('<int:pk>/update/', HSNCodeUpdateView.as_view(), name='hsncode-update'),
//     path('<int:pk>/delete/', HSNCodeDeleteView.as_view(), name='hsncode-delete'),
//     path('dropdown/', HSNCodeDropdown.as_view(), name='hsncode-dropdown'),
//     path('dropdown/<str:field_name>/', HsnDropdownView.as_view(), name='gp-master-dynamic-dropdown'),
//     path('dropdown/hsn_code_name/<str:field_name>/', Hsn_list_nameDropdownView.as_view(), name='gp-master-dynamic-dropdown'),

export const fetchhsnCodes = createAsyncThunk(
  "hsn-code/fetchhsnCodes",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any[];
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search.trim());
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      const filterPayload = FilterBuilder(filters ?? []);

      const body = {
        filters: filterPayload,
      };

      const response: any = await Axios.post(
        `${API_ENDPOINT?.MASTERS?.HSN_CODE?.LIST}?${params.toString()}`,
        body,
      );
      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      throw new Error("Failed to fetch HSN Code");
    }
  },
);

export const fetchhsnCodeById = createAsyncThunk(
  "hsn-code/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(
        API_ENDPOINT.MASTERS.HSN_CODE.DETAIL(id),
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch GST by ID");
    }
  },
);

export const fetchHsnCodeByDropDown = createAsyncThunk(
  "HsnCode/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(API_ENDPOINT.MASTERS.HSN_CODE.DROPDOWN);
      // console.log(response, "116 in hsn dropdown")
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch HsnCode list",
      );
    }
  },
);

export const updatehsnCode = createAsyncThunk(
  "hsn-code/updatehsnCode",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        API_ENDPOINT.MASTERS.HSN_CODE.UPDATE(data.id),
        data,
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update HsnCode");
    }
  },
);

export const updateStatusInhsnCode = createAsyncThunk(
  "hsn-code/updateStatusInhsnCode",
  async (data: any, { rejectWithValue }) => {
    try {
      const payload = { is_active: data.is_active };
      const response: any = await Axios.patch(
        API_ENDPOINT.MASTERS.HSN_CODE.STATUS_UPDATE(data.id),
        payload,
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update status in  HsnCode",
      );
    }
  },
);

export const addhsnCode = createAsyncThunk(
  "hsn-code/addhsnCode",
  async (data: any, { rejectWithValue }) => {
    console.log(data, "133 in add hsn code");
    try {
      const response: any = await Axios.post(
        API_ENDPOINT.MASTERS.HSN_CODE.CREATE,
        data,
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add HsnCode");
    }
  },
);

export const deletehsnCode = createAsyncThunk(
  "hsn-code/delete",
  async (id: any, { rejectWithValue }) => {
    try {
      await Axios.delete(API_ENDPOINT.MASTERS.HSN_CODE.DELETE(id));
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  },
);

// export const exportHsnCodeCSV = async () => {
//   const response = await Axios.get("/hsn/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "hsncode.csv",
//   };
// };

export const exportHsnCodeCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: {
    filterField: string;
    filterValue: any;
  }[];
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  // -----------------------------
  // Build structured filters body
  // -----------------------------
  const filterPayload = FilterBuilder(filters ?? []);

  const body = {
    filters: filterPayload,
  };

  const response = await Axios.post(
    `${API_ENDPOINT.MASTERS.HSN_CODE.EXPORT}?${params.toString()}`,
    body,
    { responseType: "blob" },
  );

  return {
    blob: response.data,
    filename: `${
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "HSN Code List"
    }_${new Date().toISOString().split("T")[0]}.csv`,
  };
};
